import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc594b14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fc594b14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc594b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc594b14')) {
      api.createRecord('fc594b14', component.options)
    } else {
      api.reload('fc594b14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc594b14&scoped=true", function () {
      api.rerender('fc594b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/BusinessSchool/index.vue"
export default component.exports